import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
// import { useAuth } from "../../app/useAuth";
import MainLayout from "../../components/layouts/main";

export default function N4Records() {
    // const auth = useAuth();
    const navigate = useNavigate();
    const [textSearch, setTextSearch] = useState("");
    const [submitSearch, setSubmitSearch] = useState(false);
    const [advancedSearch, setAdvancedSearch] = useState("all");
    const [advancedSearchText, setAdvancedSearchText] = useState("");

    const handleSubmitSearch = useCallback(() => {
        const checkAdvancedSearchObject = JSON.stringify(advancedSearchText) === JSON.stringify({});
        if (checkAdvancedSearchObject) {
            navigate(`/search/n4/${textSearch ? textSearch : advancedSearchText}`);
        } else {
            const urlParams = new URLSearchParams(advancedSearchText).toString();
            navigate(`/search/n4/advanced?${urlParams}`);
        }
        setSubmitSearch(false);
    }, [textSearch, navigate, advancedSearch, advancedSearchText]);

    useEffect(() => {
        if (submitSearch) {
            handleSubmitSearch();
        }
    }, [submitSearch, handleSubmitSearch]);

    const arrRules = [
        {
            title: "Chromosome",
            value: "chromosome",
        },
        {
            title: "Position",
            value: "position",
        },
        {
            title: "Favourable Allele",
            value: "favourable_allele",
        },
        {
            title: "Unfavourable Allele",
            value: "unfavourable_allele",
        },
        {
            title: "Target QTL",
            value: "target_qtl",
        },
    ];

    return (
        <MainLayout
            pathname="/search/n4"
            arrRules={arrRules}
            header="DNA Marker"
            exampleText={
                <div>
                    Examples - Target QTL: <span className="text-primary">DTY1.1</span>, Gn1a Allele: <span className="text-primary">A</span>,
                    <span className="text-primary"> C</span>, <span className="text-primary">T</span>, <span className="text-primary">G</span>{' '}
                    Position: <span className="text-primary">1-38024269</span>
                </div>
            }
            textSearch={textSearch}
            setTextSearch={setTextSearch}
            setSubmitSearch={setSubmitSearch}
            setAdvancedSearch={setAdvancedSearch}
            advancedSearchText={advancedSearchText}
            setAdvancedSearchText={setAdvancedSearchText}
        />
    );
}
